import { CookiesClear, SessionStorageClear } from "../submodules/Inventory-Module-Types/src/utils/storage";
/**
 * Clears all interview-related data from cookies, session storage, and localStorage
 * This should be called when starting a new interview to prevent ID mapping conflicts
 */
export const clearInterviewData = () => {
    // Clear interview-specific cookies
    CookiesClear("is_ad");
    CookiesClear("fc");
    // Clear interview-specific session storage items
    SessionStorageClear("attempt");
    SessionStorageClear("translatedAudioCollection");
    SessionStorageClear("isRefreshed");
    SessionStorageClear("interviewMetaData");
    SessionStorageClear("logs");
    SessionStorageClear("isUploaderModalOpen");
};
/**
 * Validates that the current interview session data is consistent
 * @param currentInterviewId - The current interview ID
 * @param currentCourseId - The current course ID
 * @param currentAttempt - The current attempt number
 * @returns boolean indicating if the session is valid
 */
export const validateInterviewSession = (currentInterviewId, currentCourseId, currentAttempt) => {
    const sessionData = sessionStorage.getItem("interviewMetaData");
    if (!sessionData) {
        return false;
    }
    try {
        const parsedData = JSON.parse(sessionData);
        return (parsedData.interviewId === currentInterviewId &&
            parsedData.courseId === currentCourseId &&
            (currentAttempt ? parsedData.attempts === currentAttempt : true));
    }
    catch (error) {
        console.error("Error validating interview session:", error);
        return false;
    }
};
/**
 * Logs interview session information for debugging
 * @param interviewId - The interview ID
 * @param courseId - The course ID
 * @param attempt - The attempt number
 */
export const logInterviewSession = (interviewId, courseId, attempt) => {
    console.log("Interview Session Info:", {
        interviewId,
        courseId,
        attempt,
        timestamp: new Date().toISOString(),
        url: window.location.href
    });
};
